const SidebarMarket = ({ width = "19", height = "18" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.6"
        d="M17.148 0.971C16.9698 0.675523 16.7185 0.43095 16.4183 0.260871C16.118 0.0907925 15.779 0.000946629 15.434 0H4.566C3.868 0 3.211 0.372 2.852 0.971L0.143 5.485C0.0492558 5.64041 -0.000194965 5.8185 5.77679e-07 6C0.00399429 6.96521 0.359495 7.89591 1 8.618V17C1 18.103 1.897 19 3 19H17C18.103 19 19 18.103 19 17V8.618C19.6405 7.89591 19.996 6.96521 20 6C20.0002 5.8185 19.9507 5.64041 19.857 5.485L17.148 0.971ZM17.984 6.251C17.9223 6.73382 17.6868 7.17764 17.3217 7.49952C16.9566 7.8214 16.4867 7.99931 16 8C14.897 8 14 7.103 14 6C14 5.932 13.975 5.872 13.961 5.808L13.981 5.804L13.22 2H15.434L17.984 6.251ZM8.819 2H11.18L11.993 6.065C11.958 7.137 11.08 8 10 8C8.92 8 8.042 7.137 8.007 6.065L8.819 2ZM4.566 2H6.78L6.02 5.804L6.04 5.808C6.025 5.872 6 5.932 6 6C6 7.103 5.103 8 4 8C3.51325 7.99931 3.04341 7.8214 2.67828 7.49952C2.31315 7.17764 2.07772 6.73382 2.016 6.251L4.566 2ZM8 17V14H12V17H8ZM14 17V14C14 12.897 13.103 12 12 12H8C6.897 12 6 12.897 6 14V17H3V9.858C3.321 9.941 3.652 10 4 10C4.56781 10.0003 5.12915 9.8794 5.6465 9.64539C6.16385 9.41137 6.6253 9.06963 7 8.643C7.733 9.475 8.807 10 10 10C11.193 10 12.267 9.475 13 8.643C13.3747 9.06963 13.8361 9.41137 14.3535 9.64539C14.8708 9.8794 15.4322 10.0003 16 10C16.348 10 16.679 9.941 17 9.858V17H14Z"
        fill="white"
      />
    </svg>
  );
};
export default SidebarMarket;
